/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「密碼输入框」
 * @modify Date:2021.2.17 15:22
 */
<template>
  <div class="cTextInput-container">
    <div class="input-by">
      <input
        :type="pwdObj.type"
        autocapitalize="off"
        autocorrect="off"
        :disabled="disabled"
        :placeholder="placeholder"
        :maxlength="maxlength ? maxlength : '200'"
        :value="value"
        :class="{ error: formatError, inputEdited: value }"
        @blur="handleblur"
        @focus="handleComposing"
        @input="$emit('input', $event.target.value.trim())"
      />
      <img :src="pwdObj.icon" class="icon-class" @click="showPwd" alt="">
    </div>
    <p v-if="formatError" class="inputMessage" v-html="$sanitize(message)"></p>
  </div>
</template>

<script>
export default {
  name: 'InputPwd',
  props: [
    'value',
    'placeholder', //提示信息
    'message', //错误信息
    'formatError',
    'disabled',
    'onkeypress',
    'maxlength'
  ],
  data() {
    return {
      pwdObj:{
        type:'password',
        icon:require('../../assets/img/form_password_off.svg')
      }
    };
  },
  methods: {
    //正在输入
    handleComposing() {
      this.$emit('update:formatError', false);
    },
    // 失去焦点，校验信息
    handleblur() {
      this.$emit('blur');
    },
    showPwd() {
      if (this.pwdObj.type == 'password') {
        this.pwdObj={
          type:'text',
          icon:require('../../assets/img/form_password_on.svg')
        }
      }else{
        this.pwdObj={
          type:'password',
            icon:require('../../assets/img/form_password_off.svg')
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
.cTextInput-container {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  input {
    height: 0.5rem;
    background: var(--bg-pinkcolor);
    border: 2px solid var(--maincolor);
    font-size: 0.16rem;
    line-height: 0.5rem;
    color: var(--text-graycolor);
    padding: 0 0.14rem;
    width: 100%;
    border-radius: 5px;
  }
  .inputEdited {
    background-color: #ffffff;
    color: #333333;
  }
  .error {
    border: 1px solid red;
  }
  /* IE11 禁用清除按钮（叉号） */
  input::-ms-clear {
    display: none;
  }
  /* IE11 禁用显示密码按钮（小眼睛） */
  input::-ms-reveal {
    display: none;
  }
  .inputMessage {
    position: absolute;
    top: 0.52rem;
    padding: 0 0.05rem;
    color: red;
    font-size: 0.12rem;
    line-height: 0.14rem;
    min-height: 0.28rem;
    white-space: pre-wrap;
    margin-top: 0.05rem;
  }
  .input-by{
    position: relative;
    .icon-class{
      position:absolute;
      right: 0.1rem;
      top: calc((0.5rem - .25rem) / 2);
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Input/cPwdInput.vue